<template>
    <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%">
        <el-table-column
                fixed
                prop="id"
                label="订单号"
                width="200">
        </el-table-column>
        <el-table-column
                fixed
                prop="name"
                label="商品信息"
                width="280">
            <template slot-scope="prop">
                <div style="display: flex;justify-content: center;align-content: center;">
                    <img style="width: 50px;height: 50px" :src="prop.row.commodityImage">
                    <div  style="display: grid;margin-left: 10px;">
                        <div style="font-size: 12px;color: #2894FF;">{{prop.row.commodityName}}</div>
                        <div style="font-size: 10px;">单价：{{prop.row.commodityPrice}}/{{prop.row.commodityWeight}} 数量：{{prop.row.totalWeight}}kg</div>
                    </div>
                </div>
            </template>
        </el-table-column>
        <el-table-column
                prop="payType"
                label="订单来源"
                width="95">
            <template slot-scope="prop">
                <span v-if="prop.row.payType == 'WeiXin'">小程序支付</span>
                <span v-if="prop.row.payType == 'WeiXinPublicAccount'">小程序+公账</span>
                <span v-if="prop.row.payType == 'PublicAccount'">公账</span>
                <span v-if="prop.row.payType == 'AdvanceFunds'">垫资</span>
                <span v-if="prop.row.payType == 'After'">集采后结算</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="status"
                label="订单状态"
                width="100">
            <template slot-scope="prop">
                <span v-if="prop.row.status == '0'">待绑定</span>
                <span v-if="prop.row.status == '1'">已绑定</span>
                <span v-if="prop.row.status == '2'">待发货</span>
                <span v-if="prop.row.status == '3'">已发货</span>
                <span v-if="prop.row.status == '4'">已完成</span>
                <span v-if="prop.row.status == '5'">已关闭</span>
                <span v-if="prop.row.status == '6'">售后处理</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="organizationType"
                label="采集商信息"
                width="100">
            <template slot-scope="prop">
                <el-button type="text" size="small" @click="viewCollector(prop.row.collectorId)">{{prop.row.collectorName}}</el-button>
            </template>
        </el-table-column>
        <el-table-column
                prop="amount"
                label="采集金额"
                width="180">
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="下单时间"
                width="280">
        </el-table-column>
        <el-table-column
                label="操作"
                width="150">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="view(scope.row.id)">发单详情</el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        name: "CollectorOrderTable",
        props: {
            tableData: Array
        },
        data() {
            return {
            }
        },
        methods: {
            indexMethod(index) {
                return index+1;
            },
            view(id){
                this.$emit("view",id)
            },
            viewCollector(id){
                this.$emit("viewCollector",id)
            },
        },
    }
</script>

<style scoped>
    .red{
        color: red;
    }
</style>
